import feeStructure from "../images/fees/BCF Fee Structure - Year 2026-2027.pdf";

const cyberForensicsProgramme = {
  id: 1001,
  slug: "bachelor-of-science-in-cybersecurity-and-digital-forensics",
  title: "Bachelor of Science in Cybersecurity and Digital Forensics",
  shortTitle: "BSc Cybersecurity and Digital Forensics (BCF)",
  code: "BCF",
  school: "School of ICT, Media and Engineering",
  qualification: "UNDERGRADUATE",
  award: "Bachelor of Science in Cybersecurity and Digital Forensics",
  category: "UNDERGRADUATE",
  level: "Undergraduate",
  nqfLevel: "Level 7",
  featured: true,
  brochure: null,
  feeStructure,
  applyLink: "https://sajili.zetech.ac.ke",
  enquiryEmail: "admissions@zetech.ac.ke",
  enquiryPhone: "+254 719 034 500",
  mantra: "Secure, Investigate and Defend. Shape a Safer Digital Future.",
  heroDescription:
    "Develop the skills to protect digital systems, detect cyber threats, investigate digital crimes and respond to cybersecurity incidents.",
  overview: `This future-focused degree develops cybersecurity and digital forensics professionals who can protect digital systems, detect cyber threats, investigate digital crimes and respond effectively to cybersecurity incidents. It combines computing, cybersecurity, digital investigation, information security and emerging technologies, with practical skills in securing digital infrastructure, identifying vulnerabilities, conducting forensic investigations, managing digital evidence and supporting secure digital transformation.\n\nStudents gain practical experience in cybersecurity operations, ethical hacking and penetration testing, digital forensics, threat intelligence, malware analysis, cryptography, network security, cloud security, security analytics, incident response, secure software development and emerging technologies. The programme also builds foundations in digital law, cybercrime, research, innovation and entrepreneurship.`,
  whyStudy: [
    "Study an industry-relevant curriculum in cybersecurity operations, digital forensics, threat intelligence, penetration testing, cloud security and incident response.",
    "Gain hands-on experience in ICT labs and at the Zetech University Innovation, Entrepreneurship and Technology (iZET) Hub through investigations, ethical hacking exercises, workshops and projects.",
    "Build future-ready skills in malware analysis, security analytics, cloud and network security, cryptography, IoT security, artificial intelligence and blockchain.",
    "Learn the legal, ethical and professional standards for handling and presenting digital evidence.",
    "Prepare for cybersecurity careers in government, law enforcement, financial services, telecommunications and private organisations.",
  ],
  entryRequirements: [
    "KCSE mean grade C+ (Plus) or equivalent, with a minimum of grade C in Mathematics and English/Kiswahili.",
    "OR a KNEC Diploma or equivalent qualification.",
  ],
  duration: 8,
  durationType: "Semesters",
  durationYears: "4 Academic Years",
  mode: "Blended Learning (Physical and Online)",
  fee: 90000,
  feeType: "Per Semester",
  intake: ["January", "May", "September"],
  learningOutcomes: [
    "Implement secure computing systems, networks and security controls.",
    "Detect cybersecurity threats, vulnerabilities and incidents.",
    "Conduct professional digital forensic investigations.",
    "Handle and present digital evidence in compliance with legal, ethical and professional standards.",
    "Apply research, innovation and problem-solving skills to cybersecurity and digital forensics.",
  ],
  careers: [
    "Cybersecurity Analyst",
    "Digital Forensics Analyst",
    "Cyber Threat Intelligence Analyst",
    "Security Operations Centre (SOC) Analyst",
    "Ethical Hacker / Penetration Testing Specialist",
    "Incident Response Specialist",
    "Information Security Analyst",
    "Network Security Engineer",
    "Cloud Security Specialist",
    "Information Systems Auditor",
  ],
  skills: [
    "Ethical Hacking and Penetration Testing",
    "Digital Forensics",
    "Cyber Threat Intelligence and Threat Hunting",
    "Malware Detection and Analysis",
    "Security Analytics and Visualisation",
    "Cloud Security and Virtualisation",
    "Network Security",
    "Operating Systems Security and Hardening",
    "Advanced Cryptography",
    "Internet of Things Security",
    "Artificial Intelligence and Machine Learning",
    "Blockchain Technology",
  ],
  curriculum: [
    {
      year: "Year One",
      semesters: [
        { semester: "Semester One", units: [
          { code: "BCU 111", title: "Communication Skills" },
          { code: "BCU 113", title: "Health and Wellness Management" },
          { code: "BCU 112", title: "Digital Literacy" },
          { code: "BSD 111", title: "Structured Programming and Algorithms" },
          { code: "MAT 111", title: "Basic Mathematics" },
          { code: "BCF 116", title: "Introduction to Cybersecurity and Forensic Science" },
        ] },
        { semester: "Semester Two", units: [
          { code: "BCT 121", title: "Operating Systems" },
          { code: "MAT 120", title: "Calculus I" },
          { code: "MAT 121", title: "Discrete Mathematics" },
          { code: "STA 123", title: "Probability and Statistics I" },
          { code: "BCF 126", title: "Introduction to Cryptography" },
          { code: "BCF 127", title: "Digital Law, Evidence and Cybercrime" },
        ] },
      ],
    },
    {
      year: "Year Two",
      semesters: [
        { semester: "Semester One", units: [
          { code: "BSD 211", title: "Data Structures and Algorithms" },
          { code: "BSD 213", title: "Object-Oriented Software Design Methods" },
          { code: "BDM 121", title: "Database Management Systems" },
          { code: "BCE 210", title: "Computer Organisation and Architecture" },
          { code: "BCF 215", title: "Web Systems Architecture and Development" },
          { code: "BSD 221", title: "Assembly Language Programming" },
          { code: "BCF 216", title: "Linux Systems Administration and Security" },
        ] },
        { semester: "Semester Two", units: [
          { code: "BNT 221", title: "Data Communications & Computer Networks I" },
          { code: "BCF 222", title: "Digital Forensics Investigations" },
          { code: "BCF 223", title: "Digital Forensics Tools and Techniques" },
          { code: "BCF 224", title: "Web Application Security" },
          { code: "BCE 312", title: "Artificial Intelligence" },
          { code: "MAT 220", title: "Calculus II" },
        ] },
      ],
    },
    {
      year: "Year Three",
      semesters: [
        { semester: "Semester One", units: [
          { code: "BCF 312", title: "Ethical Hacking and Penetration Testing" },
          { code: "BNT 311", title: "Distributed Computing" },
          { code: "BCF 314", title: "Database and Data Security" },
          { code: "BCF 315", title: "Mobile Device and Systems Forensics" },
          { code: "BCF 316", title: "Software Engineering and DevSecOps" },
          { code: "BCF 319", title: "Advanced Enterprise Network Services and Deployment" },
        ] },
        { semester: "Semester Two", units: [
          { code: "BCT 321", title: "Research Methods and Technical Writing" },
          { code: "BCF 321", title: "Advanced Cryptography" },
          { code: "BCF 322", title: "Malware Detection and Analysis" },
          { code: "BCF 323", title: "Information Security and Risk Management" },
          { code: "BCF 325", title: "Cyber Threat Intelligence and Threat Hunting" },
          { code: "BCF 326", title: "Internet of Things Security" },
          { code: "BDM 321", title: "Cloud Computing and Services" },
        ] },
      ],
    },
    {
      year: "Year Four",
      semesters: [
        { semester: "Semester One", units: [
          { code: "BCU 410", title: "Entrepreneurship and Innovation" },
          { code: "BCF 412", title: "Secure Software Development" },
          { code: "BCE 413", title: "Blockchain Technology" },
          { code: "BCE 412", title: "Machine Learning" },
          { code: "BCF 416", title: "Computer Network Security" },
          { code: "BCF 414", title: "Cloud Security and Virtualisation" },
          { code: "BCT 415", title: "Project Proposal" },
          { code: "BCT 414", title: "Information System Audit and Assurance" },
        ] },
        { semester: "Semester Two", units: [
          { code: "BCF 421", title: "Security Analytics and Visualisation" },
          { code: "BCF 422", title: "Advanced Information Security Management" },
          { code: "BCF 423", title: "Cyber Incident Planning and Response" },
          { code: "BCF 424", title: "Operating Systems Security and Hardening" },
          { code: "BCF 425", title: "Emerging Technologies in Cyber Security" },
          { code: "BCF 428", title: "Final Year Project (Capstone)" },
        ] },
        { semester: "Industrial Attachment", units: [
          { code: "BCU 401", title: "Industrial Attachment" },
        ] },
      ],
    },
  ],
  faqs: [
    {
      question: "What is the Bachelor of Science in Cybersecurity and Digital Forensics?",
      answer:
        "It is a four-year degree that prepares students to protect digital systems, investigate cybercrime, handle digital evidence and respond to cybersecurity incidents.",
    },
    {
      question: "What are the entry requirements for the BCF programme?",
      answer:
        "Applicants need a KCSE mean grade of C+ or equivalent, with at least grade C in Mathematics and English or Kiswahili, or a KNEC Diploma or equivalent qualification.",
    },
    {
      question: "How long does the programme take to complete?",
      answer:
        "The programme takes four academic years, comprising eight semesters, plus the industrial attachment included in the curriculum.",
    },
    {
      question: "What is the mode of delivery?",
      answer:
        "The programme uses blended learning, combining face-to-face and online learning, practical sessions in ICT labs and at the iZET Hub, projects, workshops and industrial attachment.",
    },
    {
      question: "When can I join the programme?",
      answer: "The programme has intakes in January, May and September.",
    },
    {
      question: "What is the tuition fee for the programme?",
      answer:
        "The approved 2026–2027 fee schedule lists tuition at KES 90,000 per semester. Administrative charges also apply; see the fee structure on this page for the full breakdown.",
    },
    {
      question: "What careers can BCF graduates pursue?",
      answer:
        "Graduates can pursue roles such as cybersecurity analyst, digital forensics analyst, SOC analyst, penetration testing specialist, incident response specialist, network security engineer or cloud security specialist.",
    },
    {
      question: "What practical skills does the programme cover?",
      answer:
        "Students study areas including digital forensics, ethical hacking and penetration testing, threat intelligence, malware analysis, cryptography, network and cloud security, incident response and secure software development.",
    },
  ],
  seo: {
    metaTitle: "BSc Cybersecurity and Digital Forensics (BCF) | Zetech University",
    metaDescription: "Study Cybersecurity and Digital Forensics at Zetech University. Build hands-on skills in cyber defence, ethical hacking, digital investigations and incident response.",
  },
};

export default cyberForensicsProgramme;
